export class Box {
  x1;
  x2;
  y1;
  y2;

  constructor (x1, x2, y1, y2) {
    this.x1 = x1;
    this.x2 = x2;
    this.y1 = y1;
    this.y2 = y2;

    this.addY = this.addY.bind(this);
    this.addY1 = this.addY1.bind(this);
    this.addY2 = this.addY2.bind(this);
    this.addX = this.addX.bind(this);
    this.addX1 = this.addX1.bind(this);
    this.addX2 = this.addX2.bind(this);
    this.copy = this.copy.bind(this);
  }

  addY (y) {
    this.y1 += y;
    this.y2 += y;
    return this;
  }

  addY1 (y) {
    this.y1 += y;
    return this;
  }

  addY2 (y) {
    this.y2 += y;
    return this;
  }

  addX (x) {
    this.x1 += x;
    this.x2 += x;
    return this;
  }

  addX1 (x) {
    this.x1 += x;
    return this;
  }

  addX2 (x) {
    this.x2 += x;
    return this;
  }

  copy () {
    return new Box(this.x1, this.x2, this.y1, this.y2);
  }
}
